import { Button } from "@/ui-components/ui/button";
import { Link } from "react-router-dom";
import { FileQuestion } from "lucide-react";
import { AuroraBackground } from "@/ui-components/ui/shadcn-io/aurora-background";

const PageNotFound = () => {
  return (
    <div className="h-full w-full">
      <AuroraBackground>
        <div className="w-full max-w-2xl px-6 relative z-10">
          <div className="mx-auto flex flex-col items-center text-center">
            <div className="mb-6 grid place-items-center rounded-2xl bg-white/70 p-4 ring-1 ring-black/5 backdrop-blur">
              <FileQuestion className="h-9 w-9 text-blue-600" />
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-2 tracking-tight">Diese Seite wurde nicht gefunden</h3>
            <p className="text-gray-500 max-w-md mx-auto leading-relaxed">
              Wenn das ein Fehler sein sollte, kontaktieren Sie bitte den Support.
            </p>

            <div className="flex flex-col sm:flex-row gap-2 justify-center w-full mt-6">
              <Link to="/" className="w-full sm:w-auto">
                <Button className="w-full sm:w-auto h-11 px-8 rounded-xl bg-blue-600 hover:bg-blue-700 text-white shadow-sm transition-all">
                  Zurück zur Startseite
                </Button>
              </Link>
              <Link to="/support" className="w-full sm:w-auto">
                <Button className="w-full sm:w-auto h-11 px-8 rounded-xl" variant="outline">
                  Support kontaktieren
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </AuroraBackground>
    </div>
  );
};

export default PageNotFound;
